/**
 * ClassesProvider
 * Contain most logic handing with Omnitech Api
 */


import React from 'react'
import ClassesContext from './classes-context'
import { fetchClasses } from './classes-api'
import getAllDataInParallel from '../../helpers/get-all-data-in-parallel';

export default function ClassesProvider({ children }) {

  function fetchClassesAll(params) {
    return getAllDataInParallel({
      fn: (args) => fetchClasses({
        ...params,
        ...args,
      }),
      key: 'skuSkuQuotas',
    })
  }

  const state = {
    fetchClasses,
    fetchClassesAll,
  }

  return (
    <ClassesContext.Provider value={state}>
      {children}
    </ClassesContext.Provider>
  )
};
